module.exports = __webpack_public_path__ + "img/books.16a25d68.png";